import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  arrow: {
    marginLeft: 8,
    width: 20,
    height: 20,
  },
}));
